<script setup lang="ts">
import { computed } from 'vue';
import type { IColumnDefinition, RowData, INumberColumn } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const col = computed(() => props.column as INumberColumn);

const locale = computed(() => {
  return (window as any).$app?.i18n?.locale || navigator.language || 'en';
});

const formattedValue = computed(() => {
  if (props.value === null || props.value === undefined || props.value === '') {
    return '';
  }

  // TODO:  col.value.decimals, col.value.minDecimals
  return new Intl.NumberFormat(locale.value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(props.value));
});
</script>

<template>
  <span class="itp-number-formatter text-nowrap">
    {{ formattedValue }}
  </span>
</template>
